import React from 'react'

const CheckIcon = () => (
  <svg viewBox="0 0 151.62894 130.0199875" height="10px" x="0px" y="0px" fill="#1EC38D">
    <path d="M223.23925,100.56723a8.78688,8.78688,0,0,0-12.42973,0l-80.22095,80.21952L89.19048,139.39009a8.78915,8.78915,0,0,0-12.42973,12.42973l47.613,47.613a8.78688,8.78688,0,0,0,12.42973,0L223.23925,112.997A8.78686,8.78686,0,0,0,223.23925,100.56723Z" transform="translate(-74.18553 -97.99201)"/>
  </svg>
)

export default CheckIcon
